import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { IdentityService } from './identity.service';

const ADMIN_ROLE = '2';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user: any = null;

    constructor(private router: Router, private toastr: ToastrService, private identityService: IdentityService) {}

    async loginByAuth({email, password}) {
        try {
            const response = await this.identityService.dologin({email, password});
            if (!response || !response.accessToken) {
                throw new Error('Geçersiz sunucu yanıtı');
            }
            localStorage.setItem('token', response.accessToken);
            await this.getProfile();
            this.router.navigate(['/']);
            this.toastr.success('Giriş başarılı');
        } catch (error) {
            this.toastr.error('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
        }
    }

    async getProfile() {
        const token = localStorage.getItem('token');
        if (!token) {
            this.logout();
            throw new Error('Token bulunamadı');
        }

        let payload: any;
        try {
            payload = this.decodeToken(token);
        } catch {
            this.logout();
            throw new Error('Geçersiz token');
        }

        if (payload.exp && payload.exp * 1000 < Date.now()) {
            this.logout();
            throw new Error('Token süresi dolmuş');
        }

        if (payload.role !== ADMIN_ROLE) {
            this.logout();
            throw new Error('Yetkisiz erişim');
        }

        this.user = payload;
    }

    private decodeToken(token: string): any {
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('Geçersiz token formatı');
        }
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(json);
    }

    logout() {
        localStorage.removeItem('token');
        this.user = null;
        this.router.navigate(['/login']);
    }
}
